import {defineStore} from "pinia";

export const useAuthStatusStore = defineStore("authStatusStore", {
    state: () => ({
        activeAuthStatus: false,
    }),
});

